import React from 'react';

import { Table } from 'antd/lib';

const colums = [
  {
    title: 'Tipo Sello',
    dataIndex: 'nombre',
  },
  {
    title: 'Precio',
    dataIndex: 'valor',
    render: text =>
      text.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' }),
  },
  {
    title: 'Cantidad',
    dataIndex: 'cantidad',
  },
  {
    title: 'Sub Total',
    dataIndex: 'subtotal',
    render: (text, record) =>
      (record.valor * record.cantidad).toLocaleString('es-AR', {
        style: 'currency',
        currency: 'ARS',
      }),
  },
];

class TablaMostrarReporte extends React.Component {
  render() {
    // console.log(fInicio);
    // console.log(fFin);

    return (
      <div>
        <Table
          bordered
          pagination={false}
          // style={{ maxWidth: 650, marginLeft: '20%', marginTop: 20 }}
          dataSource={this.props.data}
          columns={colums}
        />
      </div>
    );
  }
}

export default TablaMostrarReporte;
